<template>
  <div>
    <div v-if="props.exportExcel && rows.length" class="text-end mb-2"> 
  <i class="fa fa-file-excel text-success fs-4 cursor-pointer" title="Download Excel" @click="downloadCSV" ></i> 
</div>
     <input v-model="search" placeholder="Search..." class="form-control form-control-sm mb-1 mt-1"  v-if="searchTxt && rows.length>0"/>
    <span v-if="paginatedRows.length === 0" class="fw-bold fs-5">No Records...</span>
    <div v-else>

      <table class="table table-bordered custom-table">
        <thead>
          <tr>
            <th v-for="col in columns" :key="col.key" @click="sortBy(col.key)" style="cursor:pointer">
              {{ col.label }}
              <span v-if="sortKey === col.key">
                {{ sortOrder === 'asc' ? '▲' : '▼' }}
              </span>
            </th>
            <th v-if="hasAnyAction">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in paginatedRows" :key="row.id">
            <td v-for="col in columns" :key="col.key" :style="col.type === 'image' ? 'width: 60px; padding: 0;' : ''">
               <div  v-if="col && col.type =='image'" role="button"  class="img-hover-container d-inline-block position-relative cursor-pointer">
                  <i name="noimage" v-if="row[col.key] == ''" class="fas fa-image fa-3x ms-2"></i>
                 <img :src="getUrl(row[col.key])" class="w-100 h-50 img-thumbnail-a bg-white rounded p-1" alt="student Image" v-if="row[col.key]!= ''" />
                  <div class="img-preview-a p-0 w-0 bottom-0 position-absolute bg-white shadow" v-if="row[col.key] != ''">
                    <img :src="getUrl(row[col.key])" class=" h-100 img-thumbnail-a bg-white rounded p-1" alt="student Image" />
                  </div>
                </div>
             <span v-else >
              <span v-if="col && col.type=='rowData'"  role="button" @click="() => actions.showRow(row)" >
                {{ row[col.key] }}
              </span>
                <span v-else-if="col.truncatable"  :title="row[col.key]" class="d-inline-block text-truncate width-100"  data-bs-toggle="tooltip"
  data-bs-placement="top">
                 {{ row[col.key] }}
                </span>
               <span v-else-if="col && col.type=='drp'" >
                <select class="form-select form-select-sm rounded cursor-pointer" role="button" :value="row.status" @change="event => actions.drpRow?.(row, event.target.value)">
                  <option v-for="(item, index) in col.items" :key="index">
                    {{item}}
                  </option>
                </select>
               </span>
               <span v-else-if="col && col.type=='notify'" class="badge" :class="{ 'bg-success': row[col.key] === true, 'bg-danger': row[col.key] === false }"> {{ row[col.key] === true ? 'Completed' : 'Pending' }} </span>
               <span  v-else-if="col && col.type=='budget'" class="badge" :class="{ 'bg-success': row[col.key] === 'Paid', 'bg-primary': row[col.key] === 'Free', 'bg-danger': row[col.key] === 'Not Paid' }" > {{ row[col.key] || 'N/A' }} </span>
               <span  v-else-if="col && col.type=='badge'" class="badge" :class="{ 'bg-success': row[col.key] === 'Approved', 'bg-primary': row[col.key] === 'Pending', 'bg-danger': row[col.key] === 'NotApproved' }" > {{ row[col.key] || 'N/A' }} </span>
               <span  v-else-if="col && col.type=='complaint-badge'" class="badge" :class="{ 'bg-danger': row[col.key] === 'Open','bg-success': row[col.key] === 'Closed' }" > {{ row[col.key] || 'N/A' }} </span>
              <span v-else>
                {{ row[col.key] }}
              </span>
             </span>
            </td>
            <td v-if="hasAnyAction" class="text-nowrap">
              <i v-if="actions && actions.view" role="button" class="fa fa-eye me-1 text-info fs-4 cursor-pointer"
                @click="() => actions.view(row)" ></i>
              <i v-if="actions && actions.edit" role="button" class="fa fa-pencil-square-o text-success cursor-pointer fs-5 me-1"
                @click="() => actions.edit(row)"></i>
              <i v-if="actions && actions.delete" @click="() => actions.delete(row)"
                class="fa fa-trash col-3 text-danger fs-5" role="button" data-toggle="modal"
                data-target="#staticBackdrop" aria-hidden="true"></i>
                 <i v-if="actions && actions.msg" role="button" class="fab fa-whatsapp me-1 text-success fs-4 cursor-pointer"
                @click="() => actions.msg(row)" ></i>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="totalPages > 1" class="d-block justify-content-end align-items-center mt-2">
  <button class="btn btn-sm btn-light me-1"
    :disabled="currentPage === 1"
    @click="goToPage(currentPage - 1)">
    Prev
  </button>
  <button
    v-for="page in totalPages"
    :key="page"
    class="btn btn-sm"
    :class="page === currentPage ? 'btn-darknavy' : 'btn-light'"
    @click="goToPage(page)"
    style="margin: 0 2px;"
  >
    {{ page }}
  </button>
  <button class="btn btn-sm btn-light ms-1"
    :disabled="currentPage === totalPages"
    @click="goToPage(currentPage + 1)">
    Next
  </button>
</div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineProps, onMounted, watch, nextTick } from 'vue'
const props = defineProps({
  columns: {
    type: Array,
    required: true
  },
  rows: {
    type: Array,
    required: true
  },
  actions: {
    type: Object,
    default: () => ({})
  },
  searchTxt: {
    type: Boolean,
    default: true
  },
  pageSize: { type: Number, default: 10 },
    exportExcel: {
    type: Boolean,
    default: false
  }
})

const search = ref('')
watch(search, () => {
  currentPage.value = 1
})

const sortKey = ref('')
const sortOrder = ref('asc')
const currentPage = ref(1)

const filteredRows = computed(() => {
  if (!search.value) return props.rows
  const term = search.value.trim().toLowerCase()
  return props.rows.filter(row =>
    props.columns.some(col =>
      row[col.key] &&
      String(row[col.key]).toLowerCase().includes(term)
    )
  )
})

   const getUrl= (img)=> {
      let imgUrl = img.startsWith("..")
          ? img.substring(2)
          : img;
     
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
    }
const sortedRows = computed(() => {
  if (!sortKey.value) return filteredRows.value
  return [...filteredRows.value].sort((a, b) => {
    if (a[sortKey.value] < b[sortKey.value]) return sortOrder.value === 'asc' ? -1 : 1
    if (a[sortKey.value] > b[sortKey.value]) return sortOrder.value === 'asc' ? 1 : -1
    return 0
  })
})
const paginatedRows = computed(() => {
  const start = (currentPage.value - 1) * props.pageSize
  return sortedRows.value.slice(start, start + props.pageSize)
})
const totalPages = computed(() =>
  Math.ceil(sortedRows.value.length / props.pageSize)
)

function goToPage(page) {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page
  }
}
const downloadCSV = () => {
  const headers = props.columns.map(col => `"${col.label}"`).join(',')

  const csvRows = filteredRows.value.map(row => {
    return props.columns.map(col => {
let value = row[col.key]

if (col.key === 'dob' && value) {
  value = `="${value}"`
}

value = value ?? ''
      if (col.type === 'image' && value) {
        value = '=IMAGE("' + getUrl(value) + '")';
      }

      value = String(value).replace(/"/g, '""')
      return `"${value}"`
    }).join(',')
  })


  const csvContent = [headers, ...csvRows, '=IMAGE("https://schoolsmanagement.com/api/images/students/1763982033145_images%20(7).jpeg")'].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Student_Report.csv')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}


const hasAnyAction = computed(() =>
  props.actions &&
  (typeof props.actions.view === 'function' ||
    typeof props.actions.edit === 'function' ||
    typeof props.actions.msg === 'function' ||
    typeof props.actions.delete === 'function')
)

function sortBy(key) {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortKey.value = key
    sortOrder.value = 'asc'
  }
}

function initTooltips() {
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  tooltipTriggerList.forEach(function (tooltipTriggerEl) {
    new window.bootstrap.Tooltip(tooltipTriggerEl)
  })
}

watch(paginatedRows, async () => {
  await nextTick()
  initTooltips()
})

onMounted(async () => {
  await nextTick()
  initTooltips()
})
</script>
<style>
 .custom-table th, .custom-table td, .custom-table {
    border: 1px solid #c1baba87 !important;
    border-collapse: collapse;
    padding: 5px 10px;
  }
  .width-100{
    max-width:100px;
  }
.img-preview-a {
  display: none;
  top: -65px;
  left: 105%;
  border: 1px solid #f3f3f3;
}
.img-hover-container:hover .img-preview-a {
  display: block;
}
.img-preview-a img {
  max-width: 135px;
  max-height: 140px;
  object-fit: fill;
}
.img-thumbnail-a {
    max-width: 100%;
    max-height: 45px;
}
</style>